import React, { Component } from "react";
import SideBar from "../../../components/Shared/sidebar";
import NavBar from "../../../components/Shared/navbar";

import PerfilShow from "../../../components/Perfil";
import Detail from "../../../components/Perfil/detail";
import { Breadcrumb } from "react-bootstrap";
export default class Perfil extends Component {
  render() {
    let { id } = this.props.match.params;
    return (
      <div className="wrapper ">
        <SideBar isAdmin />
        <div className="main-panel" id="main">
          <NavBar rota="/cadastro" name="Editar Paciente" />
          <div className="content">
            <Breadcrumb>
              <Breadcrumb.Item href="/pacientes">
                Lista Paciente
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Informações</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row">
              <div className="col-md-4">
                <PerfilShow id={id} page="inf" />
              </div>
              <div className="col-md-8">
                <Detail id={id} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
